var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container1"},[_vm._t("sidebar"),_c('div',{staticClass:"body"},[_vm._t("mbody")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }